var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"crowded_txt"},[_c('fa-icon',{attrs:{"icon":"ban"}}),_c('span',[_vm._v("現在満員となっております")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }